import type {
  FormattedResolutionFailures,
  ResolutionFailuresResponse
} from '@library/types/resolutions/resolutionDetails';

export const transformResolutionFailures = ({
  page,
  perPage,
  response
}: {
  page: number;
  perPage: number;
  response: ResolutionFailuresResponse | undefined;
}): FormattedResolutionFailures => {
  if (!response) {
    return {
      currentPage: 0,
      data: [],
      totalPages: 0
    };
  }

  const extractWagerFailures = ({
    data: failures
  }: ResolutionFailuresResponse) => {
    return (
      failures?.map((item) => ({
        description: item.attributes?.description ?? '',
        newWagerId: item.relationships?.new_wager?.data?.id ?? ''
      })) ?? []
    );
  };

  const failuresData = extractWagerFailures(response);

  const totalPages = failuresData.length < perPage ? page : page + 1;

  return {
    currentPage: page,
    data: failuresData,
    totalPages
  };
};
